export enum AnalyticsActionTypes {
  GET_ANALYTICS = "GET_ANALYTICS",
  GET_ANALYTICS_SUCCESS = "GET_ANALYTICS_SUCCESS",
  GET_ANALYTICS_ERROR = "GET_ANALYTICS_ERROR",
}
